import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { checkPlanIsUsageRestricted } from "@/features/stripe/utils/stripe-plan";
import { useGetServiceQuota } from "@/services/restriction/get-service-quota";

export const useVerifyServiceQuota = () => {
  const { data } = useGetServiceQuota();
  const { profile } = useAuth();
  const currentPlan = profile?.plan ?? "Free";
  const shouldVerify = checkPlanIsUsageRestricted({ plan: currentPlan });
  const remains = data?.remains;
  const blocked = data?.blocked;
  const isBlocked = blocked || (remains && remains < 0);

  return {
    blocked: shouldVerify && isBlocked,
  };
};
